import { AnimationId } from '@wwf/sdk';

export const getLinkToAnimation = (
    animationId: AnimationId | undefined | null
) => {
    if (!animationId) return '';
    return `/animation?show=${animationId}`;
};
